import footer from 'html/layouts/footer.html';
import App from 'app/app.js';
import 'app/service/TranslateProviderService.js';
import 'app/service/RouterService.js';

function FooterCtrl(
  $scope,
  $uibModal,
  RouterService,
  TranslateProviderService,
  ContentStore,
  $window,
  $location,
  $filter,
  CommonService
) {
  this.canadianDomain = TranslateProviderService.isCanadianDomain();
  this.translateProviderService = TranslateProviderService;

  this.currentDate = new Date();
  this.currentYear = this.currentDate.getFullYear();
  this.routeLoadedCtrl = false;

  $scope.$on(
    '$routeChangeSuccess',
    function () {
      this.routeLoadedCtrl = true;
    }.bind(this)
  );

  this.getHelpLink = function () {
    var contentResource = TranslateProviderService.isCanadianDomain() ? 'MENU_HELP_URL_CA' : 'MENU_HELP_URL_US';
    return $filter('ltTranslateFilter')(contentResource, {});
  };

  this.goToExplainer = function () {
    RouterService.goToExplainer();
  };

  this.portraitStore = function () {
    RouterService.goToHome();
  };

  this.getPrivacyUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_PRIVACY_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'US_PRIVACY_URL');
  };

  this.getLifetouchSchoolPicturesUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_LIFETOUCH_SCHOOL_PICTURES_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'LIFETOUCH_SCHOOL_PICTURES_URL');
  };

  this.getLifetouchUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CANADA_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'LIFETOUCH_URL');
  };

  this.getSportsUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_SPORTS_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'SPORTS_URL');
  };

  this.getYearBooksUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_YEARBOOK_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'YEARBOOK_URL');
  };

  this.getCareersUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_CAREERS_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CAREERS_URL');
  };

  this.getCaPrivacyUrl = function () {
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CALIFORNIA_PRIVACY_RIGHTS_URL');
  };

  this.getNewsUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_NEWS_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'NEWS_URL');
  };

  this.getCanadaUrl = function () {
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CANADA_URL');
  };

  this.getTCUrl = function () {
    if ($window.location.hostname.indexOf('.ca') > -1 || $window.location.hostname.indexOf('my-ca.') > -1) {
      return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_TC_URL');
    }
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'US_TC_URL');
  };

  this.getAccessibilityUrl = function () {
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'ACCESSIBILITY_URL');
  };
  this.getCaAccessibilityUrl = function () {
    return ContentStore.getContent('USER_ACCESSIBLE_URLS', 'CA_ACCESSIBILITY_URL');
  };

  this.showIdentityNavigation = function () {
    return RouterService.showIdentityNavigation();
  };

  this.showExpandableBanner = function () {
    return RouterService.showExpandableBanner();
  };

  this.isInsideOfStudentIdAndPortIdFlow = function () {
    return (
      $location.path() === RouterService.paths.STUDENT_ID_INFO ||
      $location.path() === RouterService.paths.PREPAY_STUDENT_INFO ||
      $location.path() === RouterService.paths.FOUND_MATCH
    );
  };

  this.isFooterMenuDisabledPage = function () {
    return (
      $location.path() === RouterService.paths.STUDENT_ID_INFO ||
      $location.path() === RouterService.paths.PICTURE_DAY ||
      $location.path() === RouterService.paths.FOUND_MATCH ||
      $location.path() === RouterService.paths.FIND_SCHOOL ||
      $location.path() === RouterService.paths.EVENT_LIST ||
      $location.path() === RouterService.paths.PREPAY_STUDENT_INFO ||
      $location.path() === RouterService.paths.MFR_ENROLLMENT
    );
  };

  this.getLogoAlt = () => CommonService.getLogoAlt();
}

App.component('ltFooter', {
  template: footer,
  controller: [
    '$scope',
    '$uibModal',
    'RouterService',
    'TranslateProviderService',
    'ContentStore',
    '$window',
    '$location',
    '$filter',
    'CommonService',
    FooterCtrl
  ],
  controllerAs: 'footer'
});
